import { ApplicationInstanceSummaryServiceData } from 'services/GameHosting/ApplicationInstances/applicationInstanceServiceType';
import {
  PatchJobApplicationInstanceCountServiceData,
  PatchJobEmailServiceData,
  PatchJobReportProgressServiceData,
  PatchJobServiceData,
  PatchJobStatusServiceData,
  PatchJobSummaryServiceData,
  PatchJobTypeServiceData,
} from 'services/GameHosting/PatchJob/patchingServiceType';
import { SortParams } from 'types/common/sorting';
import { ChangeAction, FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_PATCH_JOB_BY_ID = 'FETCH_PATCH_JOB_BY_ID';

export const FETCH_PATCH_JOB_BY_ID_IS_PENDING = 'FETCH_PATCH_JOB_BY_ID_IS_PENDING';

export const FETCH_PATCH_JOB_BY_ID_IS_ERROR = 'FETCH_PATCH_JOB_BY_ID_IS_ERROR';

export const FETCH_REPORT_PROGRESS = 'FETCH_REPORT_PROGRESS';

export const FETCH_REPORT_PROGRESS_IS_PENDING = 'FETCH_REPORT_PROGRESS_IS_PENDING';

export const FETCH_REPORT_PROGRESS_IS_ERROR = 'FETCH_REPORT_PROGRESS_IS_ERROR';

export const FETCH_FAILED_INSTANCES = 'FETCH_FAILED_INSTANCES';

export const FETCH_FAILED_INSTANCES_IS_ERROR = 'FETCH_FAILED_INSTANCES_IS_ERROR';

export const FETCH_FAILED_INSTANCES_IS_PENDING = 'FETCH_FAILED_INSTANCES_IS_PENDING';

export const PATCH_JOB_PREVIEW = 'PATCH_JOB_PREVIEW';

export const PATCH_JOB_PREVIEW_IS_PENDING = 'PATCH_JOB_PREVIEW_IS_PENDING';

export const PATCH_JOB_PREVIEW_IS_ERROR = 'PATCH_JOB_PREVIEW_IS_ERROR';

export const HOLD_PATCH_JOB = 'HOLD_PATCH_JOB';

export const HOLD_PATCH_JOB_IS_PENDING = 'HOLD_PATCH_JOB_IS_PENDING';

export const HOLD_PATCH_JOB_IS_ERROR = 'HOLD_PATCH_JOB_IS_ERROR';

export const UN_HOLD_PATCH_JOB = 'UN_HOLD_PATCH_JOB';

export const UN_HOLD_PATCH_JOB_IS_PENDING = 'UN_HOLD_PATCH_JOB_IS_PENDING';

export const UN_HOLD_PATCH_JOB_IS_ERROR = 'UN_HOLD_PATCH_JOB_IS_ERROR';

export const FETCH_PATCHING_SUMMARY = 'FETCH_PATCHING_SUMMARY';

export const FETCH_PATCHING_SUMMARY_IS_PENDING = 'FETCH_PATCHING_SUMMARY_IS_PENDING';

export const FETCH_PATCHING_SUMMARY_IS_ERROR = 'FETCH_PATCHING_SUMMARY_IS_ERROR';

export const FETCH_PATCHING_STATUS = 'FETCH_PATCHING_STATUS';

export const FETCH_PATCHING_STATUS_IS_PENDING = 'FETCH_PATCHING_STATUS_IS_PENDING';

export const FETCH_PATCHING_STATUS_IS_ERROR = 'FETCH_PATCHING_STATUS_IS_ERROR';

export const FETCH_PATCH_JOB_TYPE = 'FETCH_PATCH_JOB_TYPE';

export const FETCH_PATCH_JOB_TYPE_IS_PENDING = 'FETCH_PATCH_JOB_TYPE_IS_PENDING';

export const FETCH_PATCH_JOB_TYPE_IS_ERROR = 'FETCH_PATCH_JOB_TYPE_IS_ERROR';

export const CREATE_PATCH_JOB = 'CREATE_PATCH_JOB';

export const CREATE_PATCH_JOB_IS_PENDING = 'CREATE_PATCH_JOB_IS_PENDING';

export const CREATE_PATCH_JOB_IS_ERROR = 'CREATE_PATCH_JOB_IS_ERROR';

export const EDIT_PATCH_JOB = 'EDIT_PATCH_JOB';

export const EDIT_PATCH_JOB_IS_PENDING = 'EDIT_PATCH_JOB_IS_PENDING';

export const EDIT_PATCH_JOB_IS_ERROR = 'EDIT_PATCH_JOB_IS_ERROR';

export const CANCEL_PATCH_JOB = 'CANCEL_PATCH_JOB';

export const CANCEL_PATCH_JOB_IS_PENDING = 'CANCEL_PATCH_JOB_IS_PENDING';

export const CANCEL_PATCH_JOB_IS_ERROR = 'CANCEL_PATCH_JOB_IS_ERROR';

export const STOP_PATCH_JOB = 'STOP_PATCH_JOB';

export const STOP_PATCH_JOB_IS_PENDING = 'STOP_PATCH_JOB_IS_PENDING';

export const STOP_PATCH_JOB_IS_ERROR = 'STOP_PATCH_JOB_IS_ERROR';

export const FETCH_REPORT_EMAIL = 'FETCH_REPORT_EMAIL';

export const FETCH_REPORT_EMAIL_IS_PENDING = 'FETCH_REPORT_EMAIL_IS_PENDING';

export const FETCH_REPORT_EMAIL_IS_ERROR = 'FETCH_REPORT_EMAIL_IS_ERROR';

export const CHANGE_REPORT_EMAIL_IN_BULK = 'CHANGE_REPORT_EMAIL_IN_BULK';

export const CHANGE_REPORT_EMAIL_IN_BULK_IS_PENDING = 'CHANGE_REPORT_EMAIL_IN_BULK_IS_PENDING';

export const CHANGE_REPORT_EMAIL_IN_BULK_IS_ERROR = 'CHANGE_REPORT_EMAIL_IN_BULK_IS_ERROR';

export const SORT = 'SORT_PATCH_JOB';

export type PatchJobReducerState = FetchReducer<
  | 'fetchById'
  | 'summary'
  | 'fetchReportProgress'
  | 'failed'
  | 'preview'
  | 'hold'
  | 'unPostPone'
  | 'status'
  | 'fetchType'
  | 'fetchEmail'
  | 'cancel'
  | 'create'
  | 'edit'
  | 'stop'
  | 'changeReportSettingInBulk'
> & {
  patchJobSummary: PatchJobSummaryServiceData[];
  patchJob: PatchJobServiceData | undefined;
  patchJobReportProgress: PatchJobReportProgressServiceData | undefined;
  patchJobFailedInstances: ApplicationInstanceSummaryServiceData[];
  preview: PatchJobApplicationInstanceCountServiceData[];
  status: PatchJobStatusServiceData[];
  type: PatchJobTypeServiceData[];
  email: PatchJobEmailServiceData[];
} & SortState<PatchJobSummaryServiceData>;

type CleanAction = {
  type: 'CLEAN_ERROR';
  reducerProperty: keyof PatchJobReducerState;
  errorIndex: number;
  mode?: string;
};

export type PatchJobActions =
  | FetchAction<'PATCH_JOB_PREVIEW', PatchJobApplicationInstanceCountServiceData[]>
  | FetchAction<'HOLD_PATCH_JOB', PatchJobServiceData>
  | FetchAction<'UN_HOLD_PATCH_JOB', PatchJobServiceData>
  | FetchAction<'FETCH_PATCH_JOB_BY_ID', PatchJobServiceData>
  | FetchAction<'FETCH_PATCHING_SUMMARY', PatchJobSummaryServiceData[]>
  | FetchAction<'FETCH_REPORT_PROGRESS', PatchJobReportProgressServiceData>
  | FetchAction<'FETCH_FAILED_INSTANCES', ApplicationInstanceSummaryServiceData[]>
  | FetchAction<'FETCH_REPORT_EMAIL', PatchJobEmailServiceData[]>
  | FetchAction<'FETCH_PATCH_JOB_TYPE', PatchJobTypeServiceData[]>
  | FetchAction<'FETCH_PATCHING_STATUS', PatchJobStatusServiceData[]>
  | FetchAction<'CANCEL_PATCH_JOB', PatchJobServiceData>
  | ChangeAction<'CREATE_PATCH_JOB'>
  | FetchAction<'EDIT_PATCH_JOB', PatchJobServiceData>
  | ChangeAction<'CHANGE_REPORT_EMAIL_IN_BULK'>
  | ChangeAction<'STOP_PATCH_JOB'>
  | { type: 'SORT_PATCH_JOB'; params: SortParams<PatchJobSummaryServiceData> }
  | { type: 'RESET_PATCHING_REDUCER' }
  | CleanAction
  | ResetReducerAction;
